var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4894 14H13.5001C13.6308 14 13.7568 13.948 13.8494 13.8573C13.9461 13.7627 14.0001 13.634 14.0001 13.5V10.198C14.0001 9.928 13.7848 9.70667 13.5148 9.698C12.4274 9.666 11.5068 9.40533 10.4368 8.82933C10.2588 8.732 10.0394 8.75267 9.8821 8.88333L8.54877 9.98133C7.5421 9.30733 6.69077 8.458 6.01277 7.45C6.0321 7.42467 6.05277 7.39733 6.07543 7.36733C6.29477 7.072 6.80943 6.38 7.03543 6.15333C7.19143 5.99733 7.22677 5.75667 7.12143 5.56267C6.58143 4.558 6.33543 3.638 6.30077 2.48467C6.2921 2.21467 6.07077 2 5.80077 2H2.5001C2.3661 2 2.23677 2.054 2.14277 2.15C2.04877 2.246 1.99743 2.376 2.0001 2.51C2.1321 8.82067 7.17877 13.8673 13.4894 14ZM13.0001 12.9773C7.63677 12.6153 3.3841 8.36267 3.0221 3H5.3281C5.40943 3.976 5.64877 4.84267 6.0801 5.724C5.84943 6.00067 5.5601 6.384 5.27277 6.77133C5.26091 6.78713 5.24963 6.80219 5.239 6.81638C5.19938 6.86924 5.16878 6.91007 5.15143 6.93267C5.15046 6.93378 5.14954 6.93483 5.14867 6.93584C5.14535 6.93967 5.1426 6.94283 5.13943 6.946C4.91877 7.19533 4.89143 7.562 5.07077 7.83733C5.87543 9.086 6.91743 10.1253 8.16743 10.9273C8.4621 11.114 8.8401 11.0747 9.05276 10.86L10.2621 9.86467C11.1888 10.3267 12.0594 10.5833 13.0001 10.6687V12.9773Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.1b7e7ec1a8d91e7743dbaaebf1d7e3f2.svg";
export { ForwardRef as ReactComponent };